const Shop: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M3.33268 2.5V5.85775L1.66602 10.8643V12.5H2.49935V17.5H10.8327V12.5H15.8327V17.5H17.4993V12.5H18.3327V10.8643L16.666 5.85775V2.5H3.33268ZM4.99935 4.16667H14.9993V5.83333H4.99935V4.16667ZM4.54199 7.5H15.4567L16.5667 10.8333H10.8327H3.43359L4.54199 7.5ZM4.16602 12.5H9.16602V15.8333H4.16602V12.5Z"
      />
    </svg>
  );
};

export default Shop;
